class MobileMenu2024 {

    initTermekbuttonEvents() {

        this.changePanel(1);

        $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').removeClass('active');

        if ($('header .termekek-wrapper').hasClass('active')) {
            $('header.termekmenu-kont').removeClass('d-none');
            // $('header.termekmenu-kont').css('top', $(window).scrollTop() + 88 + 'px');
            if (General.isMobile()) {
                $('html').css('overflow-y', 'hidden');
            }

            $('header.main-line .menu').addClass('d-none');
            $('header.termekmenu-kont .mobile-menu .menupanel').addClass('d-none');
            $('header.main-line .termekpanel-buttons').removeClass('d-none');

        } else {

            $('header.termekmenu-kont').addClass('d-none');
            if (General.isMobile()) {
                $('html').css('overflow-y', 'auto');
            }

            $('header.main-line .menu').removeClass('d-none');
            $('header.termekmenu-kont .mobile-menu .menupanel').removeClass('d-none');
            $('header.main-line .termekpanel-buttons').addClass('d-none');

        }
    }

    initpanelButtonEvents() {
        $('header.main-line .termekpanel-buttons .button-back').on('click', (e) => {
            e.preventDefault();
            if ($('header.termekmenu-kont .mobile-menu').hasClass('level-2-active')) {
                this.changePanel(1);
            }
            if ($('header.termekmenu-kont .mobile-menu').hasClass('level-3-active')) {
                if ($('header.termekmenu-kont .mobile-menu .level-2 a').length == 0) {
                    this.changePanel(1);
                } else {
                    this.changePanel(2);
                }
            }
        });

        $('header.main-line .termekpanel-buttons .button-close').on('click', (e) => {
            e.preventDefault();
            this.closeTermekMenuPanel();
        });
    }

    closeTermekMenuPanel() {
        this.changePanel(1);
        $('header .termekek-wrapper').removeClass('active');
        $('header.termekmenu-kont').addClass('d-none');
        $('html').css('overflow-y', 'auto');

        $('header.main-line .menu').removeClass('d-none');
        $('header.termekmenu-kont .mobile-menu .menupanel').addClass('d-none');
        $('header.main-line .termekpanel-buttons').addClass('d-none');

    }

    buildMobileMenuv2024() {
        if ($('header.termekmenu-kont .mobile-menu').length == 0) {
            return false;
        }

        $('header.termekmenu-kont .mobile-menu .level-1').html('');
        $('header.termekmenu-kont .panels-kont .menupanel-left .items-kont a').each((iIndex, aItem) => {
            let aItemClone = $(aItem).clone();
            let iconClass = 'icon-' + $(aItem).data('subpanel-id');
            aItemClone.addClass(iconClass);
            aItemClone.on('click touch', (e) => {
                e.preventDefault();
                this.openLevel2($(aItem).data('subpanel-id'));
                this.changePanel(2);
            });
            aItemClone.appendTo('header.termekmenu-kont .mobile-menu .level-1');
        });


        if ($('header.top-line .top-right-items .userstatemenu.mobile').hasClass('logged-in')) {
            $('header.top-line .top-right-items .userstatemenu.mobile').on('click touch', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('header.top-line .top-right-items .submenu').toggleClass('d-none');
                $(this).toggleClass('opened');

                if ($(this).hasClass('opened')) {
                    $('header.top-line').css('z-index', 1515);
                } else {
                    $('header.top-line').css('z-index', 111);
                }
            });
        }

        $('header.top-line .hamburger').on('click touch', (e) => {
            e.preventDefault();
            $('header.top-line .hamburger').toggleClass('active');
            $('header.mobilemenu-kont').toggleClass('d-none');
            // $('header.mobilemenu-kont').css('top', $(window).scrollTop() + 51 +'px');

            $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').removeClass('active');

            if (General.isMobile()) {
                if ($('header.top-line .hamburger').hasClass('active')) {
                    $('html').css('overflow-y', 'hidden');
                } else {
                    $('html').css('overflow-y', 'auto');
                }
            }

            this.buildMenupanel();
            if (!$('header.termekmenu-kont').hasClass('d-none')) {
                this.closeTermekMenuPanel();
            }

        });






    }

    buildMenupanel() {
        // main menus
        $('header.mobilemenu-kont .mobile-menuitems .main-menus').html('');


        // termékek link
        $('header.mobilemenu-kont .mobile-menuitems .termekek-open a').on('click touch', (e) => {
            e.preventDefault();
            $('header.top-line .hamburger').removeClass('active');
            $('header.mobilemenu-kont').addClass('d-none');
            $('.webshop-termek-lista-kont-2024 .kategchooser-kont .kategpanel-wrapper').removeClass('active');
            $('header.mobilemenu-kont').get(0).scrollTo({ top: 0, left: 0, behavior: "instant" });


            $('header .termekek-wrapper').addClass('active');
            this.changePanel(1);
            $('header.termekmenu-kont').removeClass('d-none');
            $('header.main-line .termekpanel-buttons').removeClass('d-none');

            $('header.main-line .menu').addClass('d-none');
            $('header.termekmenu-kont .mobile-menu .menupanel').addClass('d-none');
        });


        $('header.main-line .menuitems .menu a').each((aIndex, aItem) => {
            let newALink = $('<a>').attr('href', $(aItem).attr('href')).text($(aItem).text());
            newALink.appendTo('header.mobilemenu-kont .mobile-menuitems .main-menus');
        });

        // other menu
        $('header.mobilemenu-kont .mobile-menuitems .other-menus').html('');

        // belépés link
        let userstatemenu = $('header .btn.userstatemenu').clone();
        let newALink = $('<a>').attr('href', $(userstatemenu).attr('href')).text($(userstatemenu).text());
        newALink.appendTo('header.mobilemenu-kont .mobile-menuitems .other-menus');

        $('header.top-line .top-left-items a').each((aIndex, aItem) => {
            let text1 = $(aItem).find('span').first().text(), text2 = $(aItem).find('span').last().text();
            if (text1 == text2) {
                text2 = '';
            }
            let cssClass = $(aItem).attr('class');
            let newALink = $('<a>').attr('href', $(aItem).attr('href')).text(text1 + ' ' + text2).addClass(cssClass);
            newALink.appendTo('header.mobilemenu-kont .mobile-menuitems .other-menus');
        });

        // informations panel
        $('header.mobilemenu-kont .mobile-menuitems .informations').remove();
        let infoPanel = $('footer .col.informations').clone();
        infoPanel.removeClass('col');
        infoPanel.find('.szallitas, .fizetes').remove();
        $('header.mobilemenu-kont .mobile-menuitems').append(infoPanel);
        $('header.mobilemenu-kont .mobile-menuitems .informations .language-switcher .akt-orszag').on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).toggleClass('opened');
            $('header.mobilemenu-kont .mobile-menuitems .informations .language-switcher .orszag-list').toggleClass('d-none');
        });
    }

    openLevel2(subpanelId) {
        $('header.termekmenu-kont .mobile-menu .level-2').html('');

        let hasItem = [];

        console.log(subpanelId);

        const panelFields = $('header.termekmenu-kont .panels-kont .menupanel-right .subitem-body#body_' + subpanelId + ' fieldset');
        console.log('submenu count', panelFields.find('legend').length);
        if (panelFields.find('legend').length == 1) {
            const submenuFirst = panelFields.find('fieldset').first();
            let smf_kategoriaid = $(submenuFirst).get(0).className.replace(/.*kategoriaid-([0-9\-b]+).*/, '$1');
            console.log('submenu first kategid', smf_kategoriaid);
            if (smf_kategoriaid) {
                this.openLevel3(subpanelId, smf_kategoriaid, $(submenuFirst).find('legend').first().text());
                setTimeout(() => {
                    this.changePanel(3);
                }, 300);
                console.log('onened level 3 directly');
                return true;
            }
        }
        panelFields.each((fiIndex, fItem) => {
            if (!$(fItem).hasClass('exclude-menugen')) {

                let kategoriaid = $(fItem).get(0).className.replace(/.*kategoriaid-([0-9\-b]+).*/, '$1');
                let isBio = $(fItem).get(0).className.indexOf('bio') != -1;

                let legendItem = $(fItem).find('legend');

                if (legendItem.length == 0) {
                    legendItem = $(fItem).parent().find('legend');
                }

                if (hasItem.indexOf(legendItem.text()) == -1) {

                    let inMobileDiv = legendItem.prevAll('div.in-mobile');
                    if (inMobileDiv.length > 0) {
                        $(inMobileDiv.get().reverse()).each((bIndex, bItem) => {
                            let bannerClone = $(bItem).clone();
                            bannerClone.appendTo('header.termekmenu-kont .mobile-menu .level-2');
                        });
                    }

                    let legendLink = $('<a>').attr('href', '').text(legendItem.text());
                    hasItem.push(legendItem.text());

                    legendLink.data('kategoria-id', kategoriaid);
                    legendLink.on('click touch', (e) => {
                        e.preventDefault();
                        this.openLevel3(subpanelId, $(e.target).data('kategoria-id'), $(e.target).text());
                        this.changePanel(3);
                    });
                    legendLink.appendTo('header.termekmenu-kont .mobile-menu .level-2');
                }

            }

        });
    }

    openLevel3(subpanelId, fieldId, title) {
        console.log(subpanelId, fieldId);
        $('header.termekmenu-kont .mobile-menu .level-3 .links').html('');
        $('header.termekmenu-kont .mobile-menu .level-3 .paneltitle').text(title);

        let validFiledsets = [];
        $('header.termekmenu-kont .panels-kont .menupanel-right .subitem-body#body_' + subpanelId + ' fieldset').each((fiIndex, fItem) => {
            if (!$(fItem).hasClass('exclude-menugen')) {
                let classes = $(fItem).get(0).className.split(' ');
                if (classes.indexOf('kategoriaid-' + fieldId) > -1) {
                    validFiledsets.push(fItem);
                }
            }
        });

        console.log('valid fieldsets', validFiledsets);
        if (validFiledsets.length == 0) {
            return false;
        }

        $.each(validFiledsets, (fiIndex, fItem) => {

            let itemLinks = $(fItem).find('a');

            console.log('valid fieldsets links', itemLinks);

            $.each(itemLinks, (liIndex, liaItem) => {
                if ($(liaItem).attr('id')) {
                    let itemId = +$(liaItem).attr('id').replace('menu_termek_id_', '');
                    let itemLink = $('<a>');
                    let bioClass = $(liaItem).parent().hasClass('bio') ? 'bio' : '';
                    itemLink.html($(liaItem).html());
                    itemLink.attr('href', $(liaItem).attr('href'));
                    itemLink.addClass(bioClass);
                    itemLink.data('termek-id', itemId);
                    itemLink.appendTo('header.termekmenu-kont .mobile-menu .level-3 .links');
                }
            });

        });

    }

    changePanel(panel) {
        $('header.termekmenu-kont .mobile-menu').removeClass('level-1-active level-2-active level-3-active');
        $('header.termekmenu-kont .mobile-menu').addClass('level-' + panel + '-active');
        $('header.termekmenu-kont .mobile-menu .panel').removeClass('active');
        $('header.termekmenu-kont .mobile-menu .panel.level-' + panel).addClass('active');

        if (panel == 1) {
            $('header.main-line .termekpanel-buttons .button-back').addClass('off');
        } else {
            $('header.main-line .termekpanel-buttons .button-back').removeClass('off');
        }
    }


}

export default MobileMenu2024;
